export const getAdjustedLeft = (
    index: number,
    selectedLayer: number | null,
    transitionPhase: "default" | "newPosition",
    layers: { left: number }[]
  ): string => {
    if (transitionPhase === "default" || selectedLayer === null) {
      // Default positions
      return `${layers[index].left}%`;
    }
    if (index <= selectedLayer) {
      // Move layers to the left of or equal to the selected layer 200px left
      return `${layers[index].left - 30}%`;
    }
    if (index > selectedLayer) {
      // Move layers to the right of the selected layer 200px right
      return `${layers[index].left + 30}%`;
    }
    return "0%";
  };